<template>
  <div class="text-start" style="font-size: 18px">
    <div class="row mb-3">
      <label for="inputAccount" class="col-md-2 col-form-label">帳號</label>
      <div class="col-md-4">
        <input
          v-model="account"
          type="text"
          class="form-control"
          id="inputAccount"
          disabled
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputName" class="col-md-2 col-form-label">名稱</label>
      <div class="col-md-4">
        <input
          v-model="username"
          type="text"
          class="form-control"
          id="inputName"
          disabled
        />
      </div>
    </div>
    <div class="row mb-3">
      <label for="inputPassword" class="col-md-2 col-form-label">密碼</label>
      <div class="col-md-4">
        <input
          value="****************"
          type="password"
          class="form-control"
          id="inputPassword"
          disabled
        />
      </div>
    </div>
  </div>
  <div class="text-end">
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="updatePassword"
    >
      密碼修改
    </button>
  </div>
</template>

<script>
import { computed, inject, ref } from "vue";
import store from "@/store";
export default {
  setup() {
    const mod = inject("mod");
    const commonMethods = inject("commonMethods");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);

    const updatePassword = commonMethods.updatePassword;
    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    return { mod, updatePassword, account, username };
  },
};
</script>

<style></style>
